/**
 * Constants for audio issue detection logic.
 * These constants are used to determine when to show the audio issue error modal.
 */

import { aosTaskTypes } from '../../constants/constants';

/**
 * Theta thresholds for audio issue detection by story type.
 * When user theta is above the threshold for a story type,
 * the audio issue detection logic may trigger.
 */
export const AUDIO_ISSUE_THETA_THRESHOLDS = {
  ran: 0.5,
  wordPartDeletion: 1.25,
  nonsenseWordRepetition: -100,
  letterName: 0.5,
  letterSound: 1,
  wif: 3.5,
  nwf: 4,
  letterNamingAndSounds: 1,
  beginningLetterSound: 1,
};

/**
 * Story types that are excluded from audio issue detection.
 * These story types will not trigger the audio issue modal.
 */
export const AUDIO_ISSUE_EXCLUDED_STORY_TYPES = [
  aosTaskTypes.assessment,
  aosTaskTypes.retell,
  aosTaskTypes.upAndDown,
  aosTaskTypes.changeOnePart,
];
